<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardBody>
          <AppForm 
            :key="appFormKey"
            vo-name="ProductOrderGetVo"
            :data="tmpProductOrder" 
            @changed="onFormChange"
          />
          <CDataTable
            outlined
            hover
            striped
            :fields="productOrderItemsUiMeta"
            :items="tmpProductOrder.product_order_items"
            :noItemsView="{ noResults: i18nMessage.NoFilteredResultsAvailable, noItems: i18nMessage.NoItemsAvailable }"
          >
            <template #spec="{item}">
              <td>
                {{item.spec ? item.spec : ''}}
              </td>
            </template>
             <template #product_name="{item}">
              <td>
                <a target="_blank" :href="$router.resolve({path: `/product/${item.product_id}`}).href">{{item.product_name}}</a>
              </td>
            </template>
          </CDataTable>
        </CCardBody>
        <CCardFooter>
          <LoadingStateButton
            @click="onAddOrUpdateProductOrder"
            :text="i18nMessage.Apply"
            color="primary"
            :loading="updateProductOrderLoading"
          />
          &nbsp;
          <CButton color="secondary" @click="goBack">{{i18nMessage.Back}}</CButton>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import { mapState, mapActions, mapMutations, } from 'vuex'
import { generateGUID } from '../../util'
import AppForm from '../../components/AppForm'
import LoadingStateButton from '../../components/LoadingStateButton'

export default {
  name: 'ProductOrder',
  components: {
    AppForm,
    LoadingStateButton,
  },
  data () {
    return {
      deleteConfirmText: null,
      showDeleteModal: false,
      tmpProductOrder: {},
      updateProductOrderLoading: false,
      deleteProductOrderLoading: false,
      appFormKey: generateGUID(),
      showSectionEditor: false,
    }
  },
  computed: {
    ...mapState({
      i18nMessage: state => state.i18nMessage,
      productOrder: state => state.product.productOrder,
      productOrderItemsUiMeta: state => state.product.productOrderItemsUiMeta,
    }),
  },
  methods: {
    ...mapActions({
      getProductOrder: 'product/getProductOrder',
      updateProductOrder: 'product/updateProductOrder',
      addProductOrder: 'product/addProductOrder',
      deleteProductOrder: 'product/deleteProductOrder',
    }),
    ...mapMutations({
      setProductOrder: 'product/setProductOrder',
    }),
    goBack() {
      this.$router.push({path: '/product-order'})
    },
    onFormChange (data) {
      this.tmpProductOrder = {...data}
    },
    onAddOrUpdateProductOrder () {
      if (this.tmpProductOrder.id) {
        this.updateProductOrderLoading = true
        this.updateProductOrder(this.tmpProductOrder)
          .then(() => {
            this.updateProductOrderLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.updateProductOrderLoading = false
          })
      } else {
        this.updateProductOrderLoading = true
        this.addProductOrder(this.tmpProductOrder)
          .then(() => {
            this.updateProductOrderLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.updateProductOrderLoading = false
          })
      }
    },
    onDeleteProductOrder () {
      this.deleteProductOrderLoading = true
      this.deleteProductOrder(this.ProductOrder.id)
          .then(() => {
            this.deleteProductOrderLoading = false
            this.appFormKey = generateGUID()
            this.goBack()
          }, () => {
            this.deleteProductOrderLoading = false
            this.showDeleteModal = false
          })
    }
  },
  mounted() {
    this.getProductOrder(this.$route.params.id).then(() => {
      this.tmpProductOrder = this.productOrder
    })
  },
  destroyed() {
    this.setProductOrder({})
  }
}
</script>

<style>
  .section-modal.overlay {
    position: fixed;
    width: 100%;
    height: 100vh;
    left: 0;
    top: 0;
    background: rgba(51,51,51,0.7);
    z-index: 10;
  }

  .section-modal > .modal-header {
    padding: 5px;
  }

  .section-modal > .modal-content {
    overflow: hidden;
  }

  .section-modal > .modal-body {
    overflow-y: scroll;
    padding: 0px;
  }

  .section-modal > .modal-footer {
    display: none;
  }
</style>